import { useEffect, useState } from "react";
import debounce from "lodash/debounce";
export function useScrollTop(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.minCriticalvalue, minCriticalvalue = _c === void 0 ? 0 : _c, _d = _b.maxCriticalvalue, maxCriticalvalue = _d === void 0 ? 100000 : _d, _e = _b.scrollFinshedThreshold, scrollFinshedThreshold = _e === void 0 ? 500 : _e;
    var _f = useState(0), scrollTop = _f[0], setScrollTop = _f[1];
    useEffect(function () {
        var scrolling = false;
        var scrollTop = 0;
        var scrollEndTimer = 0;
        function handleChangeScrollTop(newScrollTop) {
            scrollTop = newScrollTop;
            setScrollTop(newScrollTop);
        }
        var scrollEnd = debounce(function (newScrollTop) {
            scrolling = false;
            if ((newScrollTop <= minCriticalvalue && scrollTop >= minCriticalvalue) ||
                (newScrollTop >= maxCriticalvalue && scrollTop <= maxCriticalvalue)) {
                handleChangeScrollTop(newScrollTop);
            }
        }, scrollFinshedThreshold, { leading: false, trailing: true });
        function scrollFn() {
            var newScrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (newScrollTop >= minCriticalvalue && newScrollTop <= maxCriticalvalue) {
                handleChangeScrollTop(newScrollTop);
            }
            if (!scrolling) {
                scrolling = true;
            }
            scrollEnd(newScrollTop);
        }
        window.addEventListener("scroll", scrollFn);
        return function () {
            window.removeEventListener("scroll", scrollFn);
            scrollEndTimer && clearTimeout(scrollEndTimer);
        };
    }, [minCriticalvalue, maxCriticalvalue, scrollFinshedThreshold]);
    return scrollTop;
}
